import { SectionData } from "shared/types";
import Image from "shared/images";
import { Visit } from "shared/visit";

export const ProjectIntro = (props: SectionData) => {
  const { title, desc, cover, section } = props;

  const color =
    section === "DISS" || section === "BLST" || section === "BYRM"
      ? "black"
      : "white";

  return (
    <div className="Sections">
      <div className={`Section ${section}`}>
        <div className="section-content">
          <div className="image">
            <Image name={cover} title={title} />
          </div>

          <div className="meta">
            <h2 className="heading h-4 m-auto line-height-1 title-font">
              {title}
            </h2>
            <h3 className="heading h-3 m-auto line-height-1 font-weight-thin">
              {desc}
            </h3>
          </div>

          <Visit
            {...{
              link: props.link,
              style: color,
            }}
          />
        </div>
      </div>
    </div>
  );
};
